<template>
  <div class="building">
    <img src="static/img/bg32.png" />
    <p>页面正在建设中...</p>
  </div>
</template>
<script>
export default {
  name: "building",
  data: function() {
    return {};
  },
  created: function() {},
  methods: {}
};
</script>

<style scoped>
.building {
  width: 100vw;
  height: 100vh;
  padding-top: 6rem;
  text-align: center;
}
.building img {
  display: block;
  width: 100%;
  height: auto;
}
.building p {
  font-size: 1.2rem;
  line-height: 250%;
  color: #419dd8;
}
</style>


// WEBPACK FOOTER //
// src/components/common/building.vue